import { setRequestListSelected } from 'actions/requestActions';

import {
    TextLine,
    SentDate,
    createNocheckCheckboxCell
} from 'components/common/tableComponents/cellTemplates';

import { RequestPosition } from './RequestPosition';

const RequestTableTemplates = {
    checkbox:   createNocheckCheckboxCell('request', setRequestListSelected),
    position:   RequestPosition,
    date:       SentDate
};

export default function getRequestTableTemplate(columnName) {
    return RequestTableTemplates[columnName] || TextLine;
}
